import { Button, Form, Input, message, Select } from 'antd';
import { TransectionApiServices } from 'features/transaction_list/api/transection-api.service';
import { useUserContext } from 'features/users';
import { FormSectionsSeparator } from 'features/users/components/modals/form-sections-separator';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ROUTES } from 'routes/constants';

type props = {
    closeModal: () => void;
    isOpen: boolean;
    modalType: string
};

interface GroupFilterTicket {
    GroupName: string;
    GroupId: any;
}

interface GroupFilterApiResponse {
    GroupList: GroupFilterTicket[];
}

export const GroupRegistrationModal = ({
    closeModal,
    isOpen,
    modalType
}: props) => {
    const { user } = useUserContext();
    const userHasAccessToEventList: any = user?.user_id != 107093;

    const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);

    const [form] = Form.useForm();
    const { t } = useTranslation();

    const [loading, setLoading] = useState<boolean>(false);
    const [isSuccess, setIsSuccess] = useState<boolean>(false);
    const [selected, setSelected] = useState('All'); // Track selected event

    const transaction = [
        { value: "all", label: "All" },
        { value: "captured", label: "Captured" },
        { value: "uncaptured", label: "UnCaptured" }
    ]

    const handleClose = () => {
        form.resetFields();
        closeModal();
        setTickets([])
    };
    const onFinish = (formValues: any) => {
        handleExport(formValues);
    };



    const handleExport = async (values: any) => {
        setLoading(true);
        //"transaction_status":"captured","group_names":1304,"event_name":10821
        try {

            // const params = {
            //     EventId:event_name,              
            //     BulkUploadId: BulkUploadId,
            //     status: status               
            // };

            // const response = await TransectionApiServices().exportGroupListByEventId(params);

            const group_names =
                typeof values.group_names === 'string'
                    ? values.group_names.toLowerCase() === 'all' || values.group_names.toLowerCase() === 'undefined'
                        ? ''
                        : values.group_names
                    : values.group_names ?? '';

            const params = {
                event_id: values.event_name,
                BulkUploadId: group_names,
                transaction_status: values.transaction_status,
                FileName: values.file_name,
                type: "GroupParticiapantReport",
            };
            const response: any = await TransectionApiServices().exportGroupListRegistraionByEventId(
                params
            );
            if (response?.ResponseStatus == 1) {

                setLoading(false);
                setIsSuccess(true);
                form.resetFields()
            } else {
                message.error(response.ResponseMessage);
            }
            // handleClose();
            //const apires = response as GroupFilterApiResponse;

            // if (response.ResponseStatus === 1) {
            //     setLoading(false);
            //     setIsSuccess(true);
            //     form.resetFields()

            // } else {
            //     message.error(response.ResponseMessage);
            // }
        } catch (error) {
            message.error("File doesn't contain valid data");
            setLoading(false);
        }
        finally {
            setLoading(false);
        }

    };


    const [event, setEvent] = useState('' as any)
    const [tickets, setTickets] = useState(
        [{ label: 'All', value: 'All' }]
    )

    const getEvent = async () => {
        try {
            // `Flag=${'Events'}`
            const apires = await TransectionApiServices().getCommonDropDown({
                flag: "Events",
                AgentId: user?.user_id
            })
            // const filteredEvents = (apires as any)?.items.filter((event: { Id: number; }) => event.Id === 732);

            //  setEvent(filteredEvents as any);
            setEvent(apires as any)
        } catch (error) {
            message.error('')
        }
    }

    // const getTickets = async (value: string) => {

    //     form.setFieldsValue({ transaction_status: '' });
    //     if (value === 'All') {
    //         // If "All" is selected, reset tickets to just "All"
    //         setTickets([{ label: 'All', value: '' }]);

    // return; // exit early, don't call API
    //     }

    //     try {
    //         const response = await TransectionApiServices().getDropDownList(
    //             `Flag=EventCategory&CascadeId=${value}`
    //         );
    //         const apires = response as ApiResponse;
    //         setTickets([
    //             { label: 'All', value: '' },
    //             ...apires.items.map((res) => ({ label: res.Text, value: res.Id }))
    //         ]);
    //     } catch (error) {
    //         message.error('');
    //     }
    // };


    const getGroupNameList = async (value: string, eventId?: string) => {
        form.setFieldsValue({ group_names: '' });

        if (value === 'All') {
            setTickets([{ label: 'All', value: '' }]);

            return;
        }

        try {
            const response = await TransectionApiServices().getGroupNameListByEventId(
                `EventId=${eventId}&Status=${value}`
            );

            const apires = response as GroupFilterApiResponse;
            setTickets([
                { label: 'All', value: '' },
                ...apires.GroupList.map((res) => ({ label: res.GroupName, value: res.GroupId }))
            ]);
        } catch (error) {
            message.error('');
        }
    };



    useEffect(() => {
        if (isOpen) {
            getEvent();
            form.setFieldValue("transaction_status", "all");
            setIsSuccess(false);
            setSelected('All')
        }

    }, [isOpen, form])

    ////Added by jonish////////
    useEffect(() => {
        if (selected !== "All") {
            // Clear validation + value for Date fields
            form.setFields([
                { name: "Date_From", errors: [], value: null },
                { name: "Date_To", errors: [], value: null },
            ]);
        }
    }, [selected, form]);
    /// END ///

    const formatTitle = (title: string) => {
        if (!title) return '';

        // Capitalize the first character
        const capitalized = title.charAt(0).toUpperCase() + title.slice(1);

        // Insert a space before "Report"
        const formatted = capitalized.replace(/([a-z])([A-Z])/g, '$1 $2');

        return formatted;
    };



    return (
        <div className='popup'>
            <div className='modal_head'>
                <h4>{formatTitle(modalType)} Export</h4>
                <button onClick={handleClose} className='close-btn'>
                    &times;
                </button>

            </div>
            <div className='modal_body'>
                <Form
                    // id={formId}
                    // name={formId}
                    className='filters-form'
                    form={form}
                    layout='vertical'
                    onFinish={onFinish}
                    // initialValues={initialValues}
                    onFinishFailed={() => {
                        setValidateTrigger(['onChange']);
                    }}
                    validateTrigger={validateTrigger}
                >
                    {/* <ContentFilters.FormItemsWrapper> */}
                    <FormSectionsSeparator title={""}>

                            <Form.Item
                                // label={t('shops.formfield.fieldName.label')}
                                label={'Event Name'}
                                name={"event_name"}
                                rules={[
                                    {
                                        required: true,
                                        message: t('validateMessages.custom.nomsg'),
                                    },
                                ]}
                            >
                                <Select
                                    showSearch
                                    options={event?.dropDownList?.filter((res: any) => (res.Id === 732 && !userHasAccessToEventList) || (res.Id === res.Id && userHasAccessToEventList)).map((res: any) => ({ label: res.Name, value: res.Id }))}
                                    placeholder={"Select Event Name"}
                                    // onChange={(value: string) => //getTickets(value)
                                    //     setGrpeventId(value)
                                    // }
                                    onChange={(value: string) => {
                                        // setGrpeventId(value);

                                        const status = form.getFieldValue("transaction_status");
                                        if (status === "all") {
                                            getGroupNameList("all", value);
                                        }
                                    }}

                                    filterOption={(input: any, option: any) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                />

                            </Form.Item>
                            {/* <Form.Item
                                // label={t('shops.formfield.fieldName.label')}
                                label={'Category Names'}
                                name={"category_names"}
                            // rules={[
                            //     {
                            //         required: true,
                            //         message: t('validateMessages.custom.nomsg'),
                            //     },
                            // ]}
                            >
                                <Select
                                    showSearch
                                    options={tickets}
                                    placeholder={"Select Event Name"}
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }

                                />
                            </Form.Item> */}



                        <Form.Item
                            label={'Transaction Status'}
                            name={"transaction_status"}
                        >
                            <Select
                                placeholder='Select Transaction Status'
                                options={transaction}
                                onChange={(value: string) => {
                                    const eventId = form.getFieldValue("event_name");
                                    getGroupNameList(value, eventId); // ⭐ FIXED
                                }}
                            />
                        </Form.Item>

                        {/* GROUP NAMES */}
                        <Form.Item
                            label={'Group Names'}
                            name={"group_names"}
                        >
                            <Select
                                showSearch
                                options={tickets}
                                placeholder={"Select Group Name"}
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                            />
                        </Form.Item>

                        <Form.Item
                            // label={t('shops.formfield.fieldName.label')}
                            label={'File Name'}
                            name={"file_name"}
                            rules={[
                                {
                                    required: true,
                                    message: t('validateMessages.custom.nomsg'),
                                },
                            ]}
                        >
                            <Input placeholder={'Enter File Name'} />
                        </Form.Item>

                    </FormSectionsSeparator>

                    {!isSuccess &&
                        <Button type='primary' htmlType='submit' loading={loading}>
                            Generate Report
                        </Button>

                    }

                </Form>
                {isSuccess && <>
                    {/* <h1>Download Report</h1> */}
                    <div className='gnrte_rprt'>
                        <h2>
                            Preparing Your Report<span className="loading">...</span>
                        </h2>

                        <h3>To Check your report status and access the file, Please <Link to={ROUTES.TRANSACTION__REPORTS}>Click here</Link></h3>
                    </div>
                </>}
            </div>
        </div>
    );
};



